import React, { useEffect } from "react";
import * as signalR from "@microsoft/signalr";
import { WrapperMap } from "Mapa";
import Layout from "Layout";
import { CSSProperties } from "styled-components";

export default function MapaView() {
  const { REACT_APP_SOCKET }: any = process.env;
  const [connection, setConnection] = React.useState<any>();
  const [isConnection, setIsConnection] = React.useState<boolean>(false);
  const [isRefresh, setIsRefresh] = React.useState<any>();

  const styles: CSSProperties = {
    fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
    backgroundColor: "none",
  };

  useEffect(() => {
    const connectionConfig: any = new signalR.HubConnectionBuilder()
      .withUrl(REACT_APP_SOCKET, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();

    connectionConfig
      .start()
      .then(() => {
        setConnection(connectionConfig);
        setIsConnection(true);
      })
      .catch((error: any) => {
        console.log(error);
      });

    return () => {
      if (connectionConfig) {
        connectionConfig.stop();
      }
    };
  }, [REACT_APP_SOCKET]);

  useEffect(() => {
    if (connection) {
      connection
        .invoke("JoinGroupAsync", "cityclub")
        .then((success: any) => {
          console.log(success);
          setIsConnection(true);
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  }, [connection]);

  useEffect(() => {
    if (connection && isConnection) {
      connection.on("update_attendance", (message: any) => {
        console.log(message);
        setIsRefresh(message);
      });
    }
  }, [connection, isConnection]);

  return (
    <Layout theme={styles}>
      <WrapperMap
        REACT_APP_API_KEY_MAPS={process.env.REACT_APP_API_KEY_MAPS}
        refresh={isRefresh}
      />
    </Layout>
  );
}
